<div class="form-field" [class.selected]="_selected">
    <span class="desc">{{ title }}</span>
    <input #field [readonly]="readonly" [type]="type" [ngModel]="_value" (ngModelChange)="_handleModelChange($event)" [placeholder]="placeholder" (focus)="_handleFocus()" (blur)="_handleBlur()" [class.spinnerHidden]="showSpinner | not">
</div>